import { create } from "zustand";

export type ThemeMode = "light" | "dark";
export type NavLayout = "sidebar" | "menubar";

export const PRESET_COLORS = [
  { label: "Flame", value: "#d84315" },
  { label: "Crimson", value: "#c62828" },
  { label: "Pink", value: "#ad1457" },
  { label: "Purple", value: "#6a1b9a" },
  { label: "Indigo", value: "#283593" },
  { label: "Blue", value: "#1565c0" },
  { label: "Teal", value: "#00695c" },
  { label: "Green", value: "#2e7d32" },
  { label: "Amber", value: "#f57f17" },
  { label: "Brown", value: "#4e342e" },
  { label: "Steel", value: "#37474f" },
  { label: "Cobalt", value: "#0277bd" },
];

export const DEFAULT_COLOR = "#d84315";

interface ThemeState {
  mode: ThemeMode;
  primaryColor: string;
  navLayout: NavLayout;
  hydrateTheme: () => void;
  toggleTheme: () => void;
  setMode: (mode: ThemeMode) => void;
  setPrimaryColor: (color: string) => void;
  setNavLayout: (layout: NavLayout) => void;
}

export const useThemeStore = create<ThemeState>((set) => ({
  mode: "light",
  primaryColor: DEFAULT_COLOR,
  navLayout: "sidebar",

  hydrateTheme: () => {
    const storedMode = localStorage.getItem("themeMode");
    const storedColor = localStorage.getItem("themePrimaryColor");
    const storedNavLayout = localStorage.getItem("navLayout");
    set({
      mode: storedMode === "dark" ? "dark" : "light",
      primaryColor: storedColor || DEFAULT_COLOR,
      navLayout: storedNavLayout === "menubar" ? "menubar" : "sidebar",
    });
  },

  toggleTheme: () =>
    set((state) => {
      const mode = state.mode === "light" ? "dark" : "light";
      localStorage.setItem("themeMode", mode);
      return { mode };
    }),

  setMode: (mode) => {
    localStorage.setItem("themeMode", mode);
    set({ mode });
  },

  setPrimaryColor: (primaryColor) => {
    localStorage.setItem("themePrimaryColor", primaryColor);
    set({ primaryColor });
  },

  setNavLayout: (navLayout) => {
    localStorage.setItem("navLayout", navLayout);
    set({ navLayout });
  },
}));
